import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'
import { getVisitById } from '../visits/visits.actions'

export const postAddOns = (visitId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_VISIT', payload })

		return api
			.post(`/visits/${visitId}/addons`, payload)
			.then((response) => {
				dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'UPDATE_VISIT_FAIL' })
			})
	}
}

export const postBoardingAddOnsAsync = async (dispatch, visitId, payload) => {
	dispatch({ type: 'UPDATE_VISIT', payload })
	try {
		const response = await api.post(`/visits/boarding/${visitId}/addons`, payload)
		const { data, errors } = response.data
		if (data && data.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: data[0] })
		}
		if (errors && errors.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'UPDATE_VISIT_FAIL' })
	}
}

export const postDaycareAddOnsAsync = async (dispatch, visitId, payload) => {
	dispatch({ type: 'UPDATE_VISIT', payload })
	try {
		const response = await api.post(`/visits/daycare/${visitId}/addons`, payload)
		const { data, errors } = response.data
		if (data && data.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: data[0] })
		}
		if (errors && errors.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'UPDATE_VISIT_FAIL' })
	}
}

export const postGroomingAddOnsAsync = async (dispatch, visitId, payload) => {
	dispatch({ type: 'UPDATE_VISIT', payload })
	// @TODO rename/refactor endpoint to /visits/grooming/:visitId/addons
	try {
		const response = await api.post(`/visits/${visitId}/grooming/addons`, payload)
		const { data, errors } = response.data
		if (data && data.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: data[0] })
		}
		if (errors && errors.length > 0) {
			dispatch({ type: 'UPDATE_VISIT_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'UPDATE_VISIT_FAIL' })
	}
}

export const updateAddOn = (addOnId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_ADD_ON' })

		return api
			.patch(`/addons/${addOnId}`, payload)
			.then((response) => {
				dispatch({ type: 'UPDATE_ADD_ON_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'UPDATE_ADD_ON_FAIL' })
			})
	}
}

export const updateMany = (payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_FACILITY' })

		return api
			.put(`/addons/updateMany`, payload)
			.then((response) => {
				dispatch(showSuccess(`Addons updated!`))
				dispatch({ type: 'UPDATEMANY_ADDON_SUCCESS', payload })
			})
			.catch(() => {
				dispatch({
					type: 'UPDATE_FACILITY_FAIL',
					payload: 'An error occured while updating the addons'
				})
			})
	}
}

export const deleteAddOn = (addOnId) => {
	return (dispatch) => {
		dispatch({ type: 'DELETE_ADD_ON' })

		return api
			.delete(`/addons/${addOnId}`)
			.then((response) => {
				dispatch({ type: 'DELETE_ADD_ON_SUCCESS', payload: response.data })
				dispatch(
					showSuccess(
						'This enrichment has been removed from the appointment and the customer will not be billed.'
					)
				)
				return response.data
			})
			.catch((e) => {
				dispatch({ type: 'DELETE_ADD_ON_FAIL' })
				const message =
					(typeof e?.data === 'string' && e.data) ||
					e?.data?.message ||
					'An error occured while deleting this enrichment.'
				dispatch(showError(message))
				return Promise.reject(e)
			})
	}
}

export const deliverAddOnForQa = (addOn, visitId) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_ADD_ON' })

		const request = addOn?._id
			? api.put(`/addons/${addOn._id}/deliver`)
			: api.put(`/addons/deliver`, {
					category: 'meal',
					visit_id: visitId || addOn.visit_id,
					pet_id: addOn.pet_id,
					date: addOn.date,
					time: addOn.time
			  })

		return request
			.then((response) => {
				const delivered = response.data?.add_on_services?.[0]
				if (delivered) {
					// tmpetcare deliver forces type:'treat' on non-meals; keep the real type for invoice UI
					dispatch({
						type: 'UPDATE_ADD_ON_SUCCESS',
						payload: {
							...delivered,
							type: addOn.type ?? delivered.type,
							category: addOn.category || delivered.category,
							name: addOn.name || delivered.name
						}
					})
				}
				dispatch(showSuccess('Delivered (QA).'))
				if (visitId) {
					dispatch(getVisitById(visitId))
				}
				return response.data
			})
			.catch(() => {
				dispatch({ type: 'UPDATE_ADD_ON_FAIL' })
				dispatch(showError('An error occured while delivering.'))
			})
	}
}
